export default __webpack_public_path__ + "static/media/step1selldone.17bcc8cc.png";